export enum DownloadFormats {
  EML = 'EML',
  PDF = 'PDF',
  EML_PDF = 'EML_PDF',
  ICS = 'ICS',
}

export enum DownloadFormatLabels {
  EML = 'EML',
  PDF = 'PDF',
  EML_PDF = 'EML & PDF',
  ICS = 'MEETING (Windows only)',
}
